declare namespace $ {

	type $mol_button_copy__title_shm_button_copy_1 = $mol_type_enforce<
		ReturnType< $shm_button_copy['title'] >
		,
		ReturnType< $mol_button_copy['title'] >
	>
	type $mol_button_copy__hint_shm_button_copy_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_copy['hint'] >
	>
	type $mol_button_copy__attr_shm_button_copy_3 = $mol_type_enforce<
		({ 
			'aria-label': ReturnType< $shm_button_copy['hint'] >,
		})  & ReturnType< $mol_button_copy['attr'] >
		,
		ReturnType< $mol_button_copy['attr'] >
	>
	type $mol_button_copy__text_shm_button_copy_4 = $mol_type_enforce<
		ReturnType< $shm_button_copy['text'] >
		,
		ReturnType< $mol_button_copy['text'] >
	>
	type $mol_button_copy__blobs_shm_button_copy_5 = $mol_type_enforce<
		ReturnType< $shm_button_copy['blobs'] >
		,
		ReturnType< $mol_button_copy['blobs'] >
	>
	type $mol_button_copy__sub_shm_button_copy_6 = $mol_type_enforce<
		ReturnType< $shm_button_copy['button_sub'] >
		,
		ReturnType< $mol_button_copy['sub'] >
	>
	type $mol_button_copy__click_shm_button_copy_7 = $mol_type_enforce<
		ReturnType< $shm_button_copy['click'] >
		,
		ReturnType< $mol_button_copy['click'] >
	>
	type $mol_view__attr_shm_button_copy_8 = $mol_type_enforce<
		({ 
			'copied': ReturnType< $shm_button_copy['copied'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_button_copy_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_blob__shm_button_copy_10 = $mol_type_enforce<
		[ readonly(BlobPart)[], ({ 
			'type': string,
		})  ]
		,
		ConstructorParameters< typeof $mol_blob >
	>
	type $mol_blob__shm_button_copy_11 = $mol_type_enforce<
		[ readonly(BlobPart)[], ({ 
			'type': string,
		})  ]
		,
		ConstructorParameters< typeof $mol_blob >
	>
	export class $shm_button_copy extends $mol_pop_over {
		event_blur( next?: any ): any
		title( ): string
		Icon( ): $mol_icon_content_copy
		button_sub( ): readonly(any)[]
		click( next?: any ): any
		Button( ): $mol_button_copy
		status_text( ): string
		Status( ): $mol_view
		text( ): ReturnType< $shm_button_copy['title'] >
		text_blob( next?: $mol_blob ): $mol_blob
		html( ): string
		html_blob( next?: $mol_blob ): $mol_blob
		copied( next?: boolean ): boolean
		hint( ): string
		event( ): ({ 
			focusout( next?: ReturnType< $shm_button_copy['event_blur'] > ): ReturnType< $shm_button_copy['event_blur'] >,
		})  & ReturnType< $mol_pop_over['event'] >
		attr( ): ({ 
			'copied': ReturnType< $shm_button_copy['copied'] >,
		})  & ReturnType< $mol_pop_over['attr'] >
		Anchor( ): ReturnType< $shm_button_copy['Button'] >
		bubble_content( ): readonly(any)[]
		blobs( ): readonly($mol_blob)[]
	}
	
}

//# sourceMappingURL=copy.view.tree.d.ts.map